import { MintStatusModel, PaginatedResponse } from '@arpeggi/shared'
import { useInfiniteQuery, UseInfiniteQueryOptions, useQuery, UseQueryOptions } from 'react-query'
import { GetMintStatusesParams, useMintStatusAPI } from '../api/v2/MintStatusAPI'
import { getNextPage, getPreviousPage } from './common'

export const useMintStatuses = ({
  params,
  options
}: {
  params: GetMintStatusesParams
  options?: UseInfiniteQueryOptions<PaginatedResponse<MintStatusModel>>
}) => {
  const { getMintStatuses } = useMintStatusAPI()

  return useInfiniteQuery(
    ['mint-statuses', params],
    ({ pageParam = params?.page || 1 }) => getMintStatuses({ ...params, page: pageParam }),
    {
      getPreviousPageParam: (firstPage) => getPreviousPage(firstPage),
      getNextPageParam: (lastPage) => getNextPage(lastPage),
      ...options
    }
  )
}

export const useMintStatus = ({
  jobId,
  options
}: {
  jobId: string
  options?: UseQueryOptions<MintStatusModel>
}) => {
  const { getOneMintStatus } = useMintStatusAPI()

  return useQuery(['mint-status', jobId], () => getOneMintStatus(jobId), options)
}
